<template>
  <div>
    <VueEcharts ref="bar"
                :option="bar"
                :init-options="initOptions"
                theme="ovilia-green"
                autoresize
                :loading="barLoading"
                :loadingOptions="barLoadingOptions"
                @zr:click="handleZrClick"
                @click="handleClick" />
    <VueEcharts ref="pie"
                :option="pie"
                :init-options="initOptions"
                autoresize />
  </div>
</template>

<script>
import qs from 'qs'
export default {
  data() {
    const options = qs.parse(location.search, { ignoreQueryPrefix: true })
    return {
      pie: {
        textStyle: {
          fontFamily: 'Inter, "Helvetica Neue", Arial, sans-serif'
        },
        title: {
          text: '提单数量看板',
          left: 'center'
        },
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b} : {c} ({d}%)'
        },
        legend: {
          orient: 'vertical',
          left: 'left',
          data: [
            // 'Direct',
            // 'Email',
            // 'Ad Networks',
            // 'Video Ads',
            // 'Search Engines'
          ]
        },
        series: [
          {
            name: '提单数量看板',
            type: 'pie',
            radius: '55%',
            center: ['50%', '60%'],
            data: [
              // { value: 335, name: 'Direct' },
              // { value: 310, name: 'Email' },
              // { value: 234, name: 'Ad Networks' },
              // { value: 135, name: 'Video Ads' },
              // { value: 1548, name: 'Search Engines' }
            ],
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      },
      bar: {
        title: {
          text: '任务效率排行',
          left: 'center'
        },
        tooltip: {
          trigger: 'item'
          // formatter: '{a} <br/>{b} : {c} ({d}%)'
        },
        textStyle: {
          fontFamily: 'Inter, "Helvetica Neue", Arial, sans-serif'
        },
        xAxis: {},
        yAxis: { type: 'category', inverse: true, data: [] },
        // Declare several bar series, each will be mapped
        // to a column of dataset.source by default.
        series: [
          {
            name: '分钟',
            type: 'bar',
            data: []
          }
        ] // { type: 'bar' }, { type: 'bar' }, { type: 'bar' }
      },
      initOptions: {
        renderer: options.renderer || 'canvas'
      },
      barLoading: false,
      barLoadingOptions: {
        text: 'Loading…',
        color: '#4ea397',
        maskColor: 'rgba(255, 255, 255, 0.4)'
      }
    }
  },
  mounted() {
    this.getpie()
    this.getbar()
  },
  methods: {
    handleClick(...args) {
      console.log('click from echarts', ...args)
    },
    handleZrClick(...args) {
      console.log('click from zrender', ...args)
    },
    random() {
      return Math.round(300 + Math.random() * 700) / 10
    },
    getpie() {
      this.$api.achievements.getPie().then((data) => {
        console.log('==x==', data)
        let other = 0
        data.forEach((element, index) => {
          if (index < 20) {
            this.pie.series[0].data.push({
              value: element.processInstanceNumber,
              name: element.processName
            })
            this.pie.legend.data.push(element.processName)
          } else {
            other += element.processInstanceNumber
          }
        })
        this.pie.series[0].data.push({
          value: other,
          name: '其他'
        })
        this.pie.legend.data.push('其他')
      })
    },
    getbar() {
      this.$api.achievements.getBar().then((data) => {
        // this.pie.legend.data.push(element.processName)
        data.forEach((element) => {
          this.bar.series[0].data.push(element.taskConsumeTime)
          // this.bar.dataset.source.push({
          //   Product: element.assigneeView,
          //   value: element.taskConsumeTime
          // })
          this.bar.yAxis.data.push(element.assigneeView)
        })
        console.log('测==', this.bar)
      })
    }
  }
}
</script>

<style>
</style>
